(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    

const tabsContainer = document.querySelector('.tabs');
if (tabsContainer) {
  const tabNav = tabsContainer.querySelector('.tab-nav');
  const tabContent = tabsContainer.querySelector('.tab-content');
  const buttons = tabNav.querySelectorAll('button');
  const panels = tabContent.querySelectorAll('.tab-panel');

  // Update button text from panel aria-label
  buttons.forEach(button => {
    const targetId = button.getAttribute('data-tab');
    const panel = document.getElementById('tab-' + targetId);
    if (panel) {
      const label = panel.getAttribute('aria-label');
      if (label) {
        button.textContent = label;
      }
    }
  });

  // Tab click handlers
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-tab');
      
      // Add class to indicate JS has taken over
      tabsContainer.classList.add('js-active');
      
      // Update buttons
      buttons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
      
      // Update panels
      panels.forEach(panel => {
        panel.classList.remove('active');
      });
      const targetPanel = document.getElementById('tab-' + targetId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
